import Schedule from '../components/Schedule'
import { useQuery } from '@tanstack/react-query'
import { GridList, LogoListItem, ErrorHandler, Loading } from '@scrippsproduct/networks-ui-library'
import { getViewingPlatforms } from '@scrippsproduct/networks-ui-library/dist/utils/getViewingPlatforms'

import logger from '@scrippsproduct/console-logger';

import '../scss/Home.scss'

const PLATFORMS_URL = process.env.REACT_APP_VIEWING_PLATFORMS;
const CURRENT_DATE = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
const ENV = process.env.REACT_APP_ENV;
logger.setNamespace('ScrippsSports');
logger.setComponent('Home');
logger.log(`Current date and time in Eastern Time: ${CURRENT_DATE.toISOString()}`);
logger.log(`ENV variable: ${ENV}`);

function Home() {
    const viewingPlatforms = useQuery({
        queryKey: ['viewingPlatforms', { network: 'scrippssports', platformsApiUrl: PLATFORMS_URL }],
        queryFn: ({ queryKey }) => {
            let { network, platformsApiUrl } = queryKey[1]
            return getViewingPlatforms({ network, platformsApiUrl })
        }
    });

    return (<>
        <div className="mobile-header-content page-hero__content">
            <p>
                Scripps Sports Network is your home for live games and original programming that bring fans closer to the action, athletes, and communities they love.
            </p>
            <a 
                href="#find-us" 
                className="find-where-to-watch-link" 
                aria-label="Find Where to Watch - Skip to main content"
            >
                Where to Watch
            </a>
        </div>
        { ((CURRENT_DATE >= new Date(2026, 2, 24) && ENV === 'production') || (ENV !== 'production')) && 
            <div id="schedule">
                <Schedule />
            </div> 
        }
        <section className='find-where-to-watch' id="find-us">
            <content-constrainer class="content-constrainer--no-border">
                <h2 className="h3">Find Where to Watch</h2>
                { (viewingPlatforms.isSuccess && viewingPlatforms?.data.size) && 
                    <GridList numberOfColumns={4}> 
                        { [...viewingPlatforms.data.values()].flat().map((item, index) => (
                            <LogoListItem 
                                href={item.link}
                                target="_blank" 
                                imageSource={item.image_url} 
                                altText={`${item.alt_text} Logo`} 
                                key={`viewing-platform-${index}`} 
                            />
                        ))}
                    </GridList>}
                    { (viewingPlatforms.isError || (viewingPlatforms.isSuccess && !viewingPlatforms?.data.size)) && <ErrorHandler 
                        title="Sorry, we're having trouble loading viewing platforms for Grit Xtra." 
                        message="Please try again later. If the problem persists please contact us at <a href='https://support.grit.com/support/home'>our support page</a>." 
                    /> }
                    { (!viewingPlatforms.isSuccess) && <Loading /> }
                {/* Uncomment the below AdBlock to add an ad unit to the homepage. 
                    Make sure to import AdBlock 
                    Make sure to add adObjMap and adData with appropriate values for the current environment
                    const ENV = process.env.REACT_APP_ENV;
                    const adObjMap = new Map([
                        ['production', {
                            campaign: 'leadgen',
                            source: 'scrippssports.com',
                            medium: 'referral',
                            content: 'findus_jessefantasy',
                        }],
                        ['staging', {
                            campaign: 'staging',
                            source: 'staging.scrippssports.com',
                            medium: 'referral',
                            content: 'findus_jessefantasy',
                        }],
                        ['local', {
                            campaign: '',
                            source: '',
                            medium: '',
                            content: '',
                        }],
                    ])

                    const adData = adObjMap.get(ENV) ?? {
                        campaign: '',
                        source: '',
                        medium: '',
                        content: '',
                    }; */}
                {/* <AdBlock 
                    ad={{
                        header: 'Fall in love with subscription-free TV.',
                        description: `Watch popular shows for free. It's not fantasy, it's reality.`,
                        href: `https://www.tablotv.com`,
                        linkText: 'See Deals',
                        ...adData,
                    }}
                    image={{
                        url:'https://cdn.scrippscloud.com/web/images/tablo/logos/Tablo_TV_Logo_2Color_White_RGB-cropped.png',
                        mobile: 'https://cdn.scrippscloud.com/web/images/tablo/logos/Tablo_TV_Logo_2Color_Navy_RGB-cropped.png',
                        altText: 'TABLO TV',
                        text: 'Internet serv. and antenna purchase req. User interface subject to change. Channels & content subj. to avail.',
                    }}
                    theme='tablotv'
                    
                /> */}
            </content-constrainer>
        </section>
    </>)
}

export default Home